var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMetamindlogoblack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2426 14.6666C11.3299 14.6666 10.5349 13.2795 10.1214 11.2299C9.70783 13.2795 8.9129 14.6666 8.00016 14.6666C7.08743 14.6666 6.2925 13.2795 5.87896 11.2299C5.4654 13.2795 4.67046 14.6666 3.75773 14.6666C2.41887 14.6666 1.3335 11.6818 1.3335 7.99992C1.3335 4.31802 2.41887 1.33325 3.75773 1.33325C4.67046 1.33325 5.4654 2.7204 5.87896 4.76992C6.2925 2.7204 7.08743 1.33325 8.00016 1.33325C8.9129 1.33325 9.70783 2.7204 10.1214 4.76992C10.5349 2.7204 11.3299 1.33325 12.2426 1.33325C13.5815 1.33325 14.6668 4.31802 14.6668 7.99992C14.6668 11.6818 13.5815 14.6666 12.2426 14.6666Z",
    fill: "#141414"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetamindlogoblack);
export default __webpack_public_path__ + "static/media/metamindlogoblack.5f63c7e877d91894d261e969d1c66794.svg";
export { ForwardRef as ReactComponent };